<template>
    <div>

    <b-form-input v-model="time" :name="`formData[${currentField.tagname}]`" type="time" :required="this.currentField.isRequired" :class="{'is-invalid' : error}"></b-form-input>
    <span class="invalid-feedback" role="alert" v-if="error">
                <strong>{{ error }}</strong>
            </span>
    </div>
</template>


<script>
export default {
  name: 'TimePicker',
  props: ['currentField', 'error'],
  data() {
    return {
      time: ''
    }
  }
}
</script>
